import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { 
    Typography, Button, Paper, Box, TextField, IconButton, Snackbar, Alert, 
    Dialog, DialogTitle, DialogContent, Table, DialogActions, TableHead, 
    TableBody, TableRow, TableCell, Radio, RadioGroup, FormControlLabel, 
    FormControl, Pagination 
} from '@mui/material';
import { Tooltip as MuiTooltip } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { myApi } from '../../config/axiosConfig';
import useMediaQuery from '@mui/material/useMediaQuery';
import Swal from 'sweetalert2';
import BtnAcciones from '../../components/plantilla/tabla/BtnAcciones';
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AgGridReact } from 'ag-grid-react';
import { AllCommunityModule } from 'ag-grid-community'; // ✅ IMPORTANTE: Registro del módulo
import img from "../../assets/img/spinner.svg";

// Iconos
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import BrowserUpdatedIcon from '@mui/icons-material/BrowserUpdated';
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from '@mui/icons-material/Delete';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import ClearIcon from '@mui/icons-material/Clear';

import CrearEditarModal from './modales/CrearEditarLoves';

const Cargas_Loves = () => {
    const PAGE_SIZE = 100;
    const [page, setPage] = useState(1);
    const [totals, setTotals] = useState(null);
    const [totalRows, setTotalRows] = useState(0);  
    const [sortModel, setSortModel] = useState([]);  

    const isNonMobile = useMediaQuery("(min-width:600px)");
    const gridRef = useRef();

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const [unit, setUnit] = useState('');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const [selected, setSelected] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [isDividing, setIsDividing] = useState(false);
    const [isMoving, setIsMoving] = useState(false);

    const [openUpdateDialog, setOpenUpdateDialog] = useState(false);
    const [updateType, setUpdateType] = useState('dia');
    const [selectedMonth, setSelectedMonth] = useState(null);

    const handleOpenModal = (carga = null, dividir = false, mover = false) => {
        setSelected(carga);
        setIsEditing(!dividir && !mover && !!carga);
        setIsDividing(dividir && !!carga);
        setIsMoving(mover && !!carga);
        setModalOpen(true);
    };

    const handleChangeUnidad = (event) => setUnit(event.target.value);

    const handleChangeStartDate = (newValue) => {
        setStartDate(newValue);
        if (endDate && newValue.isAfter(endDate)) {
            Swal.fire({
                icon: 'error',
                title: 'La fecha inicial no puede ser mayor que la fecha final.',
            }).then(() => setEndDate(newValue)); 
        }
    };

    const handleChangeEndDate = (newValue) => {
        setEndDate(newValue);
        if (startDate && newValue.isBefore(startDate)) {
            Swal.fire({
                icon: 'error',
                title: 'La fecha final no puede ser menor que la fecha inicial.',
            }).then(() => setEndDate(startDate)); 
        }
    };

    const handleClearDate = (fecha) => {
        if(fecha === 'fi') setStartDate(null); 
        else if (fecha === 'ff') setEndDate(null); 
    };

    const formatDate = (date) => {
        if (!date) return ""; 
        const d = new Date(date);
        if (isNaN(d)) return "";

        const options = {
            year: '2-digit', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', second: '2-digit',
            hour12: false,
        };
    
        const formattedDate = new Date(date).toLocaleString('en-US', options);
        const [datePart, timePart] = formattedDate.split(', ');
        const [month, day, year] = datePart.split('/');
        return `${month}/${day}/${year} ${timePart}`;
    };

    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') return;
        setSnackbarOpen(false);
    };

    const handleUpdate = async () => {
        if (updateType === 'mes' && !selectedMonth) {
            Swal.fire({ icon: 'warning', title: 'Selecciona un mes' });
            return;
        }

        let url = '/cargasFuel/uploadLoves';
        if (updateType === 'mes') {
            const fechaInicial = selectedMonth.startOf('month').format('YYYY-MM-DD');
            const fechaFinal = selectedMonth.endOf('month').format('YYYY-MM-DD');
            url = `/cargasFuel/uploadLoves?fechaInicial=${fechaInicial}&fechaFinal=${fechaFinal}`;
        }

        setOpenUpdateDialog(false);
        Swal.fire({
            icon: 'info', title: 'Cargando...', allowOutsideClick: false, showConfirmButton: false,
        });

        try {
            const resp = await myApi.get(url);
            if (!resp.data.success) throw new Error(resp.data.message);

            await Swal.fire({
                icon: 'success', title: '¡Se actualizó correctamente!', text: resp.data.message,
            });
            await fetchPage(page, sortModel);
        } catch (error) {
            Swal.fire({
                icon: 'error', title: 'Error', text: error.response?.data?.message || error.message,
            });
        }
    };

    const [openSeparaciones, setOpenSeparaciones] = useState(false);
    const [rowSeleccionado, setRowSeleccionado] = useState(null);
    const [separaciones, setSeparaciones] = useState([]);

    const handleVerMovimientos = async (row) => {
        setRowSeleccionado(row);
        setOpenSeparaciones(true);
        try {
            const resp = await myApi.get(`/cargasFuel/loves/movimientos/${row.id}`);
            if (resp.data.success) setSeparaciones(resp.data.data);
            else setSeparaciones([]);
        } catch (error) {
            console.error(error);
            setSeparaciones([]);
        }
    };

    const handleDeleteMov = useCallback(async (row) => {
        try {
            Swal.fire({
                title: '¿Está seguro de eliminar este movimiento?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: 'green',
                cancelButtonColor: 'red',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    let { data } = await myApi.delete(`/cargasFuel/loves/deleteMov/${row.id}`);
                    if (data.success) {
                        Swal.fire({ icon: 'success', title: 'Movimiento eliminado' });
                        fetchPage(page, sortModel);
                    } else {
                        Swal.fire({ icon: 'error', title: 'Error al eliminar el movimiento' });
                    }
                }
            });
        } catch (error) {
            console.error('Error deleting fuel up:', error);
        }
    }, []);

    const handleMove = useCallback((fuelRow) => {
        const carga = data.find(carga => carga.id === fuelRow.id);
        handleOpenModal(carga, false, true);
    }, [data]);

    const columns = [
        { field: 'event_date', headerName: 'Store Date & Time', cellStyle: { textAlign: "center" }, minWidth: 150, valueFormatter: (params) => formatDate(params.value), pinned: true },
        { field: 'unit', headerName: 'Unit', cellStyle: { textAlign: "center" }, minWidth: 150, pinned: true },
        { field: 'trailer', headerName: 'Trailer', cellStyle: { textAlign: "center" }, minWidth: 150, pinned: true },
        { field: 'station_name', headerName: 'Truck Stop', cellStyle: { textAlign: "center" }, minWidth: 150 },
        { field: 'station_city', headerName: 'City', cellStyle: { textAlign: "center" }, minWidth: 150 },
        { field: 'station_state', headerName: 'State', cellStyle: { textAlign: "center" }, minWidth: 150 },
        { field: 'trans_number', headerName: 'Transaction', cellStyle: { textAlign: "center" }, minWidth: 150 },
        { field: 'subtrans_number', headerName: 'Sub Transaction', cellStyle: { textAlign: "center" }, minWidth: 150 },
        { field: 'product_name', headerName: 'Product', cellStyle: { textAlign: "center" }, minWidth: 150 },
        { 
            field: 'quantity', headerName: 'Quantity', cellStyle: { textAlign: "right" }, minWidth: 150,
            valueFormatter: (params) => {
                if (!params.value) return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue)) return params.value;  
                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            }
        },
        { 
            field: 'adjusted_price', headerName: 'Unit Price', cellStyle: { textAlign: "right" }, minWidth: 150,
            valueFormatter: (params) => {
                if (!params.value) return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue)) return params.value;  
                return `$${numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
            }
        },
        { 
            field: 'adjusted_total', headerName: 'Total Amount', cellStyle: { textAlign: "right" }, minWidth: 150,
            valueFormatter: (params) => {
                if (!params.value) return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue)) return params.value;  
                return `$${numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
            }
        },
        { field: 'driver_name', headerName: 'Driver', cellStyle: { textAlign: "center" }, minWidth: 150 },
        {
            headerName: "Actions", field: "actions", width: 150, sortable: false, filter: false, suppressMenu: true, suppressColumnsToolPanel: true,
            cellRenderer: (params) => {
                const row = params.data;
                if (!row || row.isTotal) return null;

                if (row.movido > 0) {
                    return (
                        <div style={{ display: "flex", gap: 8 }}>
                            <BtnAcciones icon={<VisibilityIcon />} label="Ver movimientos" onClick={() => handleVerMovimientos(row)} />
                            <BtnAcciones icon={<DeleteIcon />} label="Eliminar movimiento" onClick={() => handleDeleteMov(row)} />
                        </div>
                    );
                }

                return (
                    <div style={{ display: "flex", gap: 8 }}>
                        <BtnAcciones icon={<TrendingFlatIcon />} label="Change Unit" onClick={() => handleMove(row)} />
                    </div>
                ); 
            },
        }
    ];

    const totalsRow = useMemo(() => {
        if (!totals) return null;
        return {
            id: "totals", unit: "TOTAL", isTotal: true,
            quantity: Number(totals.quantity || 0),
            adjusted_price: Number(totals.adjusted_price || 0),
            adjusted_total: Number(totals.adjusted_total || 0),
        };
    }, [totals]);

    const buildRequest = useCallback(() => { 
        let fechainicial = null, fechafinal = null, unidad = null; 
        if (startDate && startDate.$d !== "Invalid Date") fechainicial = startDate.$d.toJSON().substring(0, 10); 
        if (endDate && endDate.$d !== "Invalid Date") fechafinal = endDate.$d.toJSON().substring(0, 10); 
        if (unit && unit !== "undefined" && unit !== "") unidad = unit; 

        return { unidad, fi: fechainicial, ff: fechafinal }; 
    }, [startDate, endDate, unit]);
    
    const fetchPage = useCallback(async (pageToLoad = 1, sort = sortModel) => {
        setLoading(true);
        try {
            const base = buildRequest();
            const payload = { ...base, page: pageToLoad, pageSize: PAGE_SIZE, sortModel: sort };
            const resp = await myApi.post("/cargasFuel/getLovesPage", payload);

            if (!resp.data.success) {
                setData([]); setTotalRows(0); setTotals(null);
                return;
            }

            setData(resp.data.data || []);
            setTotalRows(resp.data.totalRows ?? 0);
            setTotals(resp.data.totals || null);
        } catch (e) {
            console.error(e);
            setData([]); setTotalRows(0); setTotals(null);
        } finally {
            setLoading(false);
        }
    }, [buildRequest, sortModel]);

    const handleSubmit = async () => {
        setPage(1);
        await fetchPage(1);
    };

    const totalPages = Math.max(1, Math.ceil(totalRows / PAGE_SIZE));

    const handlePageChange = async (event, value) => {
        setPage(value);
        await fetchPage(value);
    };

    const onSortChanged = (event) => {
        const cols = event.columns || [];
        const model = cols
            .filter(c => c.getSort())
            .sort((a, b) => (a.getSortIndex?.() ?? 0) - (b.getSortIndex?.() ?? 0))
            .map(c => ({ colId: c.getColId(), sort: c.getSort() }));

        setSortModel(model);
        setPage(1);
        fetchPage(1, model);
    };

    useEffect(() => {
        const load = async () => {
            setPage(1);
            await fetchPage(1);
        };
        load();
    }, []);

    const handleExportAll = async () => {
        try {
            setLoading(true);
            const base = buildRequest();
            const resp = await myApi.post(
                "/cargasFuel/getLovesExportCsv",
                { ...base, sortModel },
                { responseType: "blob" }
            );

            const blob = new Blob([resp.data], { type: "text/csv;charset=utf-8" });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "loves_export.csv";
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (e) {
            console.error(e);
            Swal.fire({ icon: "error", title: "Error", text: "No se pudo exportar" });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {/* Modal Separaciones */}
            <Dialog open={openSeparaciones} onClose={() => setOpenSeparaciones(false)} maxWidth="md" fullWidth>
                <DialogTitle>Folio {rowSeleccionado?.id}</DialogTitle>
                <DialogContent>
                    <Table size="small">
                        <TableHead>
                            <TableRow><TableCell align="center">NUEVA UNIDAD</TableCell></TableRow>
                        </TableHead>
                        <TableBody>
                            {separaciones.map((sep) => (
                                <TableRow key={sep.id}>
                                    <TableCell align="center">{sep.unit}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenSeparaciones(false)}>Cerrar</Button>
                </DialogActions>
            </Dialog>

            {/* Modal Actualizar */}
            <Dialog open={openUpdateDialog} onClose={() => setOpenUpdateDialog(false)} maxWidth="xs" fullWidth>
                <DialogTitle>Actualizar cargas LOVE'S</DialogTitle>
                <DialogContent>
                    <FormControl sx={{ mt: 1 }}>
                        <RadioGroup value={updateType} onChange={(e) => setUpdateType(e.target.value)}>
                            <FormControlLabel value="dia" control={<Radio />} label="Actualizar día actual" />
                            <FormControlLabel value="mes" control={<Radio />} label="Actualizar mes completo" />
                        </RadioGroup>
                    </FormControl>
                    {updateType === 'mes' && (
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="Mes a actualizar"
                                views={['year', 'month']}
                                value={selectedMonth}
                                onChange={setSelectedMonth}
                                slotProps={{ textField: { fullWidth: true, sx: { mt: 2 } } }}
                            />
                        </LocalizationProvider>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenUpdateDialog(false)}>Cancelar</Button>
                    <Button variant="contained" onClick={handleUpdate}>Actualizar</Button>
                </DialogActions>
            </Dialog>

            {/* Contenedor Principal */}
            <Paper
                sx={{
                    p: 2,
                    height: "calc(100vh - 125px)", // ✅ Altura corregida como en Cargas Colombia
                    width: "100%",
                    maxWidth: "100%",
                    display: "flex",
                    flexDirection: "column",
                    boxSizing: "border-box",
                }}
            >
                <Box sx={{ flexShrink: 0 }}>
                    <form onSubmit={(e) => e.preventDefault()}>
                        <Grid container>
                            <Grid size={{ xs: 12, md: 8 }}>
                                <Typography variant="h4" fontWeight={700}>
                                    Cargas de LOVE'S
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12, md: 4 }} sx={{ display: 'flex', justifyContent: isNonMobile ? 'flex-end' : 'start' }}>
                                <Button
                                    variant="contained"
                                    startIcon={<BrowserUpdatedIcon />}
                                    onClick={() => setOpenUpdateDialog(true)}
                                    sx={{ backgroundColor: 'black', marginBottom: 1 }}
                                >
                                    Actualizar
                                </Button>
                            </Grid>
                            <Grid container spacing={2} alignItems="center" sx={{ mt: 1 }}>
                                <Grid size={{ xs: 12, sm: 3 }}>
                                    <TextField label="Unidad" variant="outlined" value={unit} onChange={handleChangeUnidad} fullWidth />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 3 }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker value={startDate} onChange={handleChangeStartDate} format="MM/DD/YY" label="Fecha Inicial" slotProps={{ textField: { fullWidth: true } }} />
                                    </LocalizationProvider>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 3 }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker value={endDate} onChange={handleChangeEndDate} format="MM/DD/YY" label="Fecha Final" slotProps={{ textField: { fullWidth: true } }} />
                                    </LocalizationProvider>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 3 }}>
                                    <Button
                                        type="button" color="inherit" onClick={handleSubmit} variant="contained"
                                        startIcon={<ManageSearchIcon />} sx={{ color: "primary", fontWeight: "bold" }}
                                    >
                                        Buscar
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </form>
                </Box>

                {/* Sección de la Tabla / Grid */}
                <Box sx={{ flex: 1, minHeight: 0, mt: 1, display: "flex", flexDirection: "column" }}>
                    <Box sx={{ flexShrink: 0, mb: 1, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <Button variant="contained" onClick={handleExportAll}>
                            Exportar a Excel
                        </Button>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                            <Typography variant="body2">
                                {totalRows.toLocaleString("en-US")} registros
                            </Typography>
                            <Pagination
                                page={page} count={totalPages} onChange={handlePageChange}
                                color="primary" size="small" showFirstButton showLastButton
                            />
                        </Box>
                    </Box>

                    <Box sx={{ flex: 1, minHeight: 0, width: "100%", position: "relative" }}>
                        {loading && (
                            <Box sx={{
                                position: "absolute", inset: 0, zIndex: 10, display: "flex",
                                justifyContent: "center", alignItems: "center", background: "rgba(255,255,255,0.6)"
                            }}>
                                <img alt="Cargando..." width="120" height="120" src={img} style={{ borderRadius: "50%" }} />
                            </Box>
                        )}

                        <div className="ag-theme-quartz" style={{ height: "100%", width: "100%" }}>
                            <AgGridReact
                                modules={[AllCommunityModule]} // ✅ Registrado correctamente
                                ref={gridRef}
                                rowData={data}
                                columnDefs={columns}
                                defaultColDef={{ resizable: true, sortable: true }}
                                pinnedBottomRowData={totalsRow ? [totalsRow] : []}
                                getRowId={(params) => params.data.id}
                                suppressPaginationPanel={true}
                                onSortChanged={onSortChanged}
                                enableCellTextSelection={true}
                            />
                        </div>
                    </Box>
                </Box>
            </Paper>

            <CrearEditarModal
                open={modalOpen} onClose={() => setModalOpen(false)}
                refresh={() => fetchPage(page, sortModel)} carga={selected}
                isEditing={isEditing} isDividing={isDividing} isMoving={isMoving}
            />

            <Snackbar open={snackbarOpen} autoHideDuration={2000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
                <Alert onClose={handleCloseSnackbar} severity="success" variant="filled">
                    Texto copiado al portapapeles ✅
                </Alert>
            </Snackbar>
        </>
    );
};

export default Cargas_Loves;